import { IAppConsentsModelToSend } from 'service/SettingsService/SettingsServiceModels'

export const  UNSPECIFIED_INCOME_TYPE = 'unspecifiedIncome' 

export enum ApplicantDataFieldNames {
   name = "name",
   surname = "surname",
   email = "email",
   phoneNumber = "phoneNumber",
   street = "street",
   houseNumber = "houseNumber",
   flatNumber = "flatNumber",
   postalCode = "postalCode",
   city = "city",
   personalId = "personalId", // PESEL
   personalIdNumber = "personalIdNumber", // Dowód osobisty
   personalIdRelease = "personalIdRelease",
   personalIdValidity = "personalIdValidity"
}

export interface IFormSubmitionIncomeDataModel {
   type: typeof UNSPECIFIED_INCOME_TYPE;
   incomePerMonth: number; 
}

export interface ILoanAmountLimitationsModel {
   minimalLoanAmountToDisplayAdditionalFields: number;
   amountToPay: number;
}


export interface ILoanAdditioanMObywatelDataModel extends ILoanAmountLimitationsModel{
   billingCompany: string;
}

export interface IVideoVerificationAdditionalData {
   sessionId: string;
   payingBillCompany: string;
}

export interface IExtendedInfoFieldsToModel {
   // Dane z formularza rozszerzonego
   [ApplicantDataFieldNames.personalId] : string; //PESEL - zawsze
   [ApplicantDataFieldNames.personalIdNumber]?: string; //Numer dowodu osobistego
   [ApplicantDataFieldNames.personalIdRelease]?: string;
   [ApplicantDataFieldNames.personalIdValidity]?: string;
}

export interface IFormSubmitionModel extends IExtendedInfoFieldsToModel { //Rozszerzeamy o dane z IExtendedInfoFieldsToModel !!
   // Dane z formularza podstawowego
   [ApplicantDataFieldNames.name] : string;
   [ApplicantDataFieldNames.surname] : string;
   [ApplicantDataFieldNames.email] : string;
   [ApplicantDataFieldNames.phoneNumber] : string;

   // Dane z formularza adresowego
   [ApplicantDataFieldNames.city]: string;
   [ApplicantDataFieldNames.postalCode]: string;
   [ApplicantDataFieldNames.street]: string;
   [ApplicantDataFieldNames.houseNumber] : string;
   [ApplicantDataFieldNames.flatNumber] : string; 

   consents: IAppConsentsModelToSend[];
   payingBillCompany: string;
   jsc: string;
   hdim: string;
}
export interface IRetentionSubmitionModel {
   consents: IAppConsentsModelToSend[];
   payingBillCompany: string;
   jsc: string;
   hdim: string;
}


export interface IMObywatelSubmitionModel {
   consents: IAppConsentsModelToSend[];
   [ApplicantDataFieldNames.email] : string;
   [ApplicantDataFieldNames.phoneNumber] : string;


   payingBillCompany: string;
   jsc: string;
   hdim: string;
}

export interface IVideoVerificationSubmitionModel {
   consents: IAppConsentsModelToSend[];
   [ApplicantDataFieldNames.email] : string;
   [ApplicantDataFieldNames.phoneNumber] : string;

      // Dane z formularza adresowego
   [ApplicantDataFieldNames.city]: string;
   [ApplicantDataFieldNames.postalCode]: string;
   [ApplicantDataFieldNames.street]: string;
   [ApplicantDataFieldNames.houseNumber] : string;
   [ApplicantDataFieldNames.flatNumber] : string; 

   sessionId: string;
   payingBillCompany: string;
   jsc: string;
   hdim: string;
}

export interface ISubmitFormResponse {
   alphaId: string;
} 

export interface IAdditionalRetentionData {
   payingBillCompany: string;
   jsc: string;
   hdim: string;
} 